import { EditorProps } from "react-data-grid";
import { MenuItem, Select } from "@mui/material";
import { Row } from "./TabularDataView";
import { ReactNode, useState } from "react";
import { Data } from "datasheets/model/core/Workbook";
import { dataCacheAtom } from "datasheets/model/atoms/WorkbookAtoms";
import { useAtomValue } from "jotai";

export const ChoiceFormatter = (options: string[]) => {
  return ({ row, column, onRowChange }: EditorProps<Row, Row>): ReactNode => (
    <DropDownFormatter
      options={options}
      currentValue={row[column.key]}
      onChange={(value) => onRowChange({ ...row, [column.key]: value })}
    />
  );
};

export const KeyFormatter = (
  referenceSheetId: string,
  optionsColumnId: string
) => {
  return ({ row, column, onRowChange }: EditorProps<Row, Row>): ReactNode => (
    <DropDownFormatterWrapper
      referenceSheetId={referenceSheetId}
      optionsColumnId={optionsColumnId}
      currentValue={row[column.key]}
      onChange={(value) => onRowChange({ ...row, [column.key]: value })}
    />
  );
};

function DropDownFormatterWrapper({
  referenceSheetId,
  optionsColumnId,
  currentValue,
  onChange,
}: {
  currentValue: string;
  referenceSheetId: string;
  optionsColumnId: string;
  onChange: (value: string) => void;
}) {
  const dataCache = useAtomValue(dataCacheAtom);
  const referenceSheet: Data = dataCache[referenceSheetId];
  const options = Object.values(referenceSheet).map(
    (row) => row[optionsColumnId]
  );
  return (
    <DropDownFormatter
      options={options}
      currentValue={currentValue}
      onChange={onChange}
    />
  );
}

function DropDownFormatter({
  currentValue,
  options,
  onChange,
}: {
  currentValue: string;
  options: string[];
  onChange: (value: string) => void;
}) {
  const [value, setValue] = useState(
    //!!currentValue && currentValue !== "" ? currentValue : options[0]
    currentValue
  );
  // On open, update current value to default
  //nChange(value);
  return (
    <Select
      onChange={(event) => {
        setValue(event.target.value);
        onChange(event.target.value);
      }}
      value={value}
      sx={{ width: "100%", height: "100%" }}
    >
      {options.map((label) => {
        return (
          <MenuItem key={label} value={label}>
            {label}
          </MenuItem>
        );
      })}
    </Select>
  );
}
